import React, { Component } from 'react';
import * as moment from 'moment';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants.js'
import { Button, Divider } from 'semantic-ui-react'
import { serverIp } from '../../../../config/constants';
import axios from 'axios'

export class SetToOutForDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    setToOutForDelivery = () => {
        console.log("funk1 ++++: setToOutForDelivery");
        console.log("funk12 email:" + this.props.user.email);
        console.log("funk12 user uuid:" + this.props.user.uid);
        console.log("funk12 order_num:" + this.props.order.order_num);

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {}

        axios.post(serverIp + 'orders/setToOutForDelivery', {
            apiKey: this.props.user.uid,
            enteredBy: this.props.user.email,
            order_num: this.props.order.order_num
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("true.. ");

                    alert(response.data.message);

                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
                alert("FAILED TO UPDATE ORDER");
            });
    }

    render() {

        return (
            <div>
                <Divider horizontal>{'OUT FOR DELIVERY'}</Divider>
                <Button fluid color='red' onClick={this.setToOutForDelivery}> OUT FOR DELIVERY  </Button>

            </div>

        )
    }
}

export default SetToOutForDelivery;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/SetToOutForDelivery/SetToOutForDelivery.js